import { UiVaultConfig } from 'src/@types/vaults';
import { VaultManagerIcon } from '../VaultManagerIcon';
import { VaultTags } from '../VaultTags';

export const VaultInfoCell = (props: {
	uiVaultConfig: UiVaultConfig;
	numOfVaultSnapshots: number;
}) => {
	return (
		<div className="flex items-center gap-x-sm">
			<VaultManagerIcon size={24} uiVaultConfig={props.uiVaultConfig} />
			<div className="flex flex-col gap-y-xs">
				<span className="typo-t3 text-text-default">
					{props.uiVaultConfig.name}
				</span>
				<VaultTags
					uiVaultConfig={props.uiVaultConfig}
					numOfVaultSnapshots={props.numOfVaultSnapshots}
				/>
			</div>
		</div>
	);
};
